export enum RAMKitEnum {
  Single = 1,
  Dual = 2,
  Quad = 4
}
